import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContractTypeForecastService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ContractTypeForecastCreateDto,
  ContractTypeForecastDto,
  ContractTypeForecastExcelDownloadDto,
  ContractTypeForecastUpdateDto,
} from '../proxy/controlling/dtos/contract-type-forecast';
import { CONTRACTTYPEFORECAST_CONFIG, CONTRACTTYPEFORECAST_FIELDS } from './contract-type-forecast.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-contract-type-forecast',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ContractTypeForecastService, ConfirmationService],
  templateUrl: './contract-type-forecast.html',
  styleUrl: './contract-type-forecast.scss',
})
export class ContractTypeForecast extends BaseHierarchicalCrudComponent<
  ContractTypeForecastDto,
  ContractTypeForecastCreateDto,
  ContractTypeForecastUpdateDto,
  ContractTypeForecastExcelDownloadDto
> {
  service = inject(ContractTypeForecastService);
  config = CONTRACTTYPEFORECAST_CONFIG;
  fields = CONTRACTTYPEFORECAST_FIELDS;

  protected prepareUpdateDto(data: any, selected: ContractTypeForecastDto): ContractTypeForecastUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ContractTypeForecast';
  }
}
